module.exports = __webpack_public_path__ + "images/emoji/incoming_envelope.ffe69799a1940a5448be.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/incoming_envelope.png
// module id = MsJe
// module chunks = 24